import { render } from "./InfosModal.vue?vue&type=template&id=f9d559fc"
import script from "./InfosModal.vue?vue&type=script&lang=js"
export * from "./InfosModal.vue?vue&type=script&lang=js"

import "./InfosModal.vue?vue&type=style&index=0&id=f9d559fc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__